<template>
<div>
  <form :action="action" method="post" :accept-charset="acceptCharset" ref="form">
    <div class="paymentGroup">
      <input type="hidden" name="_token" :value="csrfToken">
      <input type="hidden" name="cpno" :value="cpno">
      <input type="hidden"
        v-for="(value, key) in informalPaymentArray"
        :key="key"
        :name="key" :value="value"
      >
      <div class="paymentGroup__item" :class="item.name" v-for="item in paymentMethods" :key="item.name">
        <label>
          <input type="radio" name="career" :value="item.name" v-model="selected">
          <span>{{ item.label }}</span>
        </label>
      </div>
    </div>
    <div class="u-tx-right">
      <button class="btn"
        data-size="sm"
        data-color="primary"
        :disabled="selected === ''"
        @click="handleSubmit"
      >お支払い</button>
    </div>
  </form>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { PAYEE } from '@/CONSTS'

export default {
  name: 'payment-method-select',
  data() {
    return {
      csrfToken: window.Laravel.csrfToken,
      cpno: window.Laravel.cpno,
      selected: '',
      action: '',
      informalPaymentArray: {},
      creditInformalPaymentArray: {},
      // 支払い方法の種別
      paymentMethods: [
        {
          name: PAYEE.DOCOMO_CODE,
          label: PAYEE.DOCOMO_LABEL,
          informalPaymentArray: this.docomoInformalPaymentArray
        }, {
          name: PAYEE.KDDI_CODE,
          label: PAYEE.KDDI_LABEL,
          informalPaymentArray: this.kddiInformalPaymentArray
        }, {
          name: PAYEE.SOFTBANK_CODE,
          label: PAYEE.SOFTBANK_LABEL,
          informalPaymentArray: this.softbankInformalPaymentArray
        }
      ]
    }
  },
  props: {
    payee: String,
    acceptCharset: { type: String, default: 'Shift_JIS' },
    sbpsApiUrl: { type: String, required: true },
    purchased: Boolean,
    orderId: String,
    merchantId: String,
    serviceId: String,
    docomoInformalPaymentArray: { type: Object, required: true },
    kddiInformalPaymentArray: { type: Object, required: true },
    softbankInformalPaymentArray: { type: Object, required: true },
    formParam: { type: Object, required: true }
  },
  computed: {
    ...mapState({
      card: state => state.payment.card
    }),
    ...mapGetters(['cardNumberStr'])
  },
  mounted() {
    if (this.card.number) {
      // カードでの決済履歴がある場合は決済手段にクレジット決済を追加
      this.paymentMethods.unshift({
        name: PAYEE.CREDIT_CODE,
        label: `${PAYEE.CREDIT_LABEL} ${this.cardNumberStr}`,
        informalPaymentArray: this.creditInformalPaymentArray
      })
      this.getCreditInformalPaymentArray()
    }
  },
  watch: {
    // ｖ-model変更のタイミングで参照するinformalPaymentArrayを切り替える
    selected() {
      const selected = this.paymentMethods.find(item => item.name === this.selected)
      if (selected) {
        this.informalPaymentArray = selected.informalPaymentArray
      }
      this.action = this.isCarrierPayment(selected.name) ? this.sbpsApiUrl : '/payment/complete'
    }
  },
  methods: {
    /**
     * キャリア決済かどうかを判定する
     * @param {String} payeeCode - 決済のsbpsのコード
     * @return {Boolean}
     */
    isCarrierPayment(payeeCode) {
      const carrierPaymentCodes = [
        PAYEE.DOCOMO_CODE,
        PAYEE.KDDI_CODE,
        PAYEE.SOFTBANK_CODE
      ]
      return carrierPaymentCodes.includes(payeeCode)
    },
    getSelectedPaymentDataObject() {
      return this.paymentMethods.find(item => item.name === this.selected)
    },
    /**
     * カード決済に必要なパラメータを取得
     */
    getCreditInformalPaymentArray() {
      Object.assign(this.creditInformalPaymentArray, this.formParam)
      Object.assign(this.creditInformalPaymentArray, {
        order_id: this.orderId,
        merchant_id: this.merchantId,
        service_id: this.serviceId
      })
    },
    /**
     * Submit時の処理
     */
    handleSubmit($evt) {
      $evt.preventDefault()
      if (!this.getSelectedPaymentDataObject()) {
        return false
      }
      this.$refs.form.submit()
    }
  }
}</script>

<style scoped lang="scss">
.paymentGroup {
  label {
    display: flex;
    align-items: center;
    margin-bottom: 0.5em;
  }

  input[type="radio"] {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    margin-right: .25em;
    border: 2px solid #AAA;
    display: flex;
    align-items: center;
    justify-content: center;
    &:checked {
      border-color: #8CC63F;
      outline: none;
    }

    &::after {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background: #8CC63F;
      transform: scale(0);
      transition: transform 200ms ease-in-out;
    }

    &:checked::after {
      transform: scale(1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/PaymentMethodSelect.vue